import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { MessagesConsumer } from '../contexts/MessagesContext';

const Messages = () => {
    return (
        <MessagesConsumer>
            {context => context && context.getMessages().map((m, i) => (
                <Container key={i}>
                    <Alert variant={m.type} onClose={() => context.removeMessage(m)} dismissible>
                        {m.message}
                    </Alert>
                </Container>
            ))}
        </MessagesConsumer>
    );
}

export default Messages;